import { useState, useEffect } from "react";
import { ADMIN_API_BASE } from "../utils/apiConfig";

export function useAdminAuth() {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkSession = async () => {
            try {
                const res = await fetch(`${ADMIN_API_BASE}/session`, {
                    credentials: "include", // 👈 send cookies
                });

                const data = await res.json();
                setIsAdmin(data.isAdmin);
            } catch (err) {
                console.error("Session check failed", err);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkSession();
    }, []);

    return { isAdmin, loading };
    return true;
}
